__turbopack_context__.v({
  "className": "playfair_display_d3aa70b3-module__paFqBG__className",
  "variable": "playfair_display_d3aa70b3-module__paFqBG__variable",
});
